// extracted by mini-css-extract-plugin
export var displayNone = "_u7-6";
export var imgContainer = "_u7-2";
export var overflowHidden = "_u7-3";
export var productInfoCardButtonContainer = "_u7-5";
export var productTitleText = "_u7-4";
export var rightArrow = "_u7-1";
export var rightArrowContainer = "_u7-0";